import React from "react"
import { useSelector } from "react-redux"

import ReviewDetail from "@/components/Review/v1/Review.view"
import { selectPdpState } from "@/store/features/pdpSlice"

const Review = props => {
  const {
    pdp: { sku = "", variants = [] },
    productInfo = {},
  } = useSelector(selectPdpState)
  const variant = variants.find(v => v.sku === sku) ?? {}
  return sku && variant?.discontinued && productInfo ? (
    <></>
  ) : (
    <ReviewDetail bazaarVoiceProductId={sku} productInfo={productInfo} />
  )
}

export default Review
